import { gql } from "@apollo/client";

export const CREATE_PROPOSALS = gql`
  mutation CreateProposal($document: String!) {
    CreateProposal(document: $document) {
      id
      document
      code
      status
      status_reason
      step
      status_reason
      steps {
        id
        step
      }
    }
  }
`;

export const SEND_PROPOSAL_STEP = gql`
  mutation SendProposalStep(
    $proposal_id: String!
    $step: String!
    $birthdate: String
    $area_code: String
    $cell_phone_number: String
    $token: String
    $username: String
    $password: String
    $answer_quiz: [AnswersQuizTypeInput]
  ) {
    SendProposalStep(
      proposal_id: $proposal_id
      step: $step
      birthdate: $birthdate
      area_code: $area_code
      cell_phone_number: $cell_phone_number
      token: $token
      username: $username
      password: $password
      answer_quiz: $answer_quiz
    ) {
      id
      document
      code
      status
      status_reason
      status_reason
      step
      steps {
        id
        step
      }
      quiz {
        id
        question
        type
        mode
        options {
          text
          value
        }
      }
    }
  }
`;

export const UPDATE_PROPOSAL_STEP = gql`
  mutation UpdateProposalStep(
    $proposal_id: String!
    $step_id: String!
    $birthdate: String
    $area_code: String
    $cell_phone_number: String
    $username: String
  ) {
    UpdateProposalStep(
      proposal_id: $proposal_id
      step_id: $step_id
      birthdate: $birthdate
      area_code: $area_code
      cell_phone_number: $cell_phone_number
      username: $username
    ) {
      id
      status
      step
      status_reason
      code
    }
  }
`;

export const DELETE_PROPOSAL = gql`
  mutation DeleteProposal($proposal_id: String!) {
    DeleteProposal(proposal_id: $proposal_id) {
      status
    }
  }
`;
